import React, { useMemo } from "react";
import { countries } from "country-data-list";

// Update these paths to where your components actually live
import Input from "../../../../components/FormComponents/Input";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import { getLabelForKey } from "../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditPhone = (props) => {
  const { editFieldData, setEditFieldData } = props;

  // 1. Prepare Country Data for SingleSelectBox
  const countryOptions = useMemo(() => {
    return countries.all
      .filter((c) => c.countryCallingCodes && c.countryCallingCodes.length > 0)
      .map((c) => ({
        name: c.name,
        code: c.countryCallingCodes[0],
        // SingleSelectBox might use this for internal keys
        id: c.alpha2
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, []);

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };

  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({
      ...editFieldData,
      validate: { ...editFieldData.validate, [name]: value }
    });
  };

  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />

      {/* Validation Row 1 */}
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>

      {/* Validation Row 2 */}
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("mandatory")}
          checked={editFieldData.validate.mandatory}
          name="mandatory"
          containerClassName="w_50"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
        />
        <Input
          type="checkbox"
          label={getLabelForKey("backend_validation")}
          checked={editFieldData.validate.backend_validation}
          name="backend_validation"
          size="medium"
          containerClassName="w_50"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
        />
      </div>
      <Input
        type="checkbox"
        label={getLabelForKey("disable_country_code")}
        checked={editFieldData.disable_country_code}
        name="disable_country_code"
        containerClassName="w_50"
        onChange={({ target }) => handleChangeInput(target.name, target.checked)}
      />
      {/* --- Country Code Selection with Search --- */}
      <SingleSelectBox
        label={getLabelForKey("default_country_code")}
        placeholder="Search Country"
        options={countryOptions}
        valueKey="code"
        labelKey={["name", "code"]}
        selectedData={editFieldData.default_country_code}
        onChange={(option) => {
          // option is null if cleared, or the object {name, code, id}
          const val = option ? option.code : "";
          handleChangeInput("default_country_code", val);
        }}
        isSearch={true}
      />

      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditPhone;
